module.exports = __webpack_public_path__ + "static/media/partner-static-image.6c590d66.png";